export enum MENU_ITEM {
  USERS = 'USERS',
  REPAIR_LIST = 'REPAIR_LIST',
  GUARANTEES_LIST = 'GUARANTEES_LIST',
}
